import React from 'react'
import { Link } from 'react-router-dom'

function SingleEventThreeLess({eventItems}) {

  return (
    <div className="row-topper">
        {
            eventItems.length > 0 && (
                <div className="row">
                {
                    eventItems.map((eventDrip, index) => {
                        return <div className="col-md-4 pd20" key={index}>
                                    <Link to={"/single-dripp/" + eventDrip._id}
                                        className="link-dripp">
                                        <div 
                                            className="card-layer-portrait"
                                            style={{
                                                backgroundImage: `url(${eventDrip.featureUrl})`
                                            }}>
                                            <div className="overlay-order">
                                                <div className="order-event">
                                                    {eventDrip.eventOrder}
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                    })
                }
                </div>
            )
        }
    </div>
  )
}

export default SingleEventThreeLess